// Company information for Gofers Varanasi Tourism
// NOTE: Packages and Blogs are now fetched from backend API

export const companyInfo = {
  name: "Gofers",
  tagline: "Your Gateway to Spiritual Varanasi",
  description: "Gofers is a premier tour and travel company based in Varanasi, dedicated to providing authentic spiritual experiences. We specialize in curated tour packages that showcase the rich cultural heritage and divine essence of Banaras.",
  email: "wegofers@gmail.com",
  phone: "+91 8960260606",
  address: "Shiv Shakti Complex, Lanka BHU Main Road, Varanasi",
  whatsapp: "",
  logo: "https://customer-assets.emergentagent.com/job_wander-hub-5/artifacts/m1zmh7oh_507218ae-a735-4e86-aaf5-24c928ef705f.jpeg"
};